<app-listing-details-cta-villages-desktop
  [footnote]="footnote()"
  [image]="image()"
  [price]="price()"
  class="hidden lg:block"
  (lppClicked)="lppClicked.emit()"
/>
<app-listing-details-cta-villages-mobile
  [footnote]="footnote()"
  [image]="image()"
  [price]="price()"
  class="block lg:hidden"
  (lppClicked)="lppClicked.emit()"
/>
